/**
 * IMPORTS
 */
import {gql} from '@apollo/client';


/**
 * EXPORTS
 */

/**
 * I am a mutation to create a new conversation.
 */
export const CREATE_CONVERSATION = gql`
mutation createConversation (
  $account: Int!,
  $agent: String!,
  $company: Int!,
  $contact: String!,
  $contactName: String!,
  $subject: String
) {
  createConversation(
    account: $account,
    agent: $agent,
    company: $company,
    contact: $contact,
    contactName: $contactName,
    subject: $subject
  ) {
    __typename
    ... on CreateConversation{
      dynamic
      id
      lastInteraction
      start
      templateRequired
    }
    ... on Error {
      code
      info
    }
  }
}
`;


/**
 * I am a mutation to finish a conversation.
 */
export const FINISH_CONVERSATION = gql`
mutation exitConversation ($agent: String!,
                           $company: Int!,
                           $id: Int!,
                           $session: String!) {
  exitConversation(agent: $agent,
                   company: $company,
                   id: $id,
                   session: $session) {
    __typename
    ... on ExitConversation {
      id
    }
    ... on Error {
      code
      info
    }
  }
}
`;


/**
 * I am a mutation to force finish a conversation.
 */
export const FORCE_FINISH = gql`
mutation finishConversation ($conversation: Int!) {
  finishConversation(conversation: $conversation) {
    conversation
  }
}
`;


/**
 * I am a mutation to free an outgoing conversation.
 */
export const FREE_CONVERSATION = gql`
mutation freeConversation ($conversation: Int!) {
  freeConversation(conversation: $conversation)
}
`;


/**
 * I am a mutation to transfer a conversation.
 */
export const TRANSFER_CONVERSATION = gql`
mutation transferConversation ($id: Int!,
                               $to: String!,
                               $uid: String!) {
  transferConversation(id: $id, to: $to, uid: $uid) {
    __typename
    ... on TransferConversation {
      id
    }
    ... on Error {
      code
      info
    }
  }
}
`;


/**
 * I am a mutation to retry a message
 */
export const RETRY_MESSAGE = gql`
mutation retryMessage($company: Int!, $conversationId: Int!, $messageId: Int!) {
  retryMessage(company: $company,
               conversationId: $conversationId,
               messageId: $messageId) {
    __typename
    ... on Message {
      id
    }
    ... on Error {
      code
      info
    }
  }
}
`;


/**
 * I am a mutation to send a message
 */
export const SEND_MESSAGE = gql`
mutation sendMessage(
        $body: String!,
        $caption: String,
        $company: Int!,
        $contact: String!,
        $conversation: Int!,
        $originalId: String!,
        $reply: String,
        $retry: String,
        $sender: String!,
        $type: Int!,
) {
  sendMessage(
    body: $body,
    caption: $caption,
    company: $company,
    contact: $contact,
    conversation: $conversation,
    originalId: $originalId,
    reply: $reply,
    retry: $retry,
    sender: $sender,
    type: $type,
  ) {
    __typename
    ... on Message {
      id
      originalId
    }
    ... on Error {
      code
      info
    }
  }
}
`;


/**
 * I am a mutation to send paused status
 */
export const SEND_PAUSED = gql`
mutation setPaused(
  $agent: String!,
  $away: Boolean!,
  $paused: Boolean!
) {
  setPaused(
    agent: $agent,
    away: $away,
    paused: $paused
  )
}
`
;


/**
 * I am a mutation to send a template message
 */
export const SEND_TEMPLATE = gql`
mutation sendTemplate(
  $company: Int!,
  $conversation: Int!,
  $from: String!,
  $originalId: String!,
  $template: TemplateInput!,
) {
  sendTemplate(
    company: $company,
    conversation: $conversation,
    from: $from,
    originalId: $originalId
    template: $template,
  ) {
    __typename
    ... on SendTemplate {
      ack
      body
      caption
      deleted
      id
      originalId
      outgoing
      referral
      reply
      timestamp
      type
    }
    ... on Error {
      code
      info
    }
  }
}
`;


/**
 * I am a mutation to dispatch the quality analysis of conversations.
 */
export const ANALYZE_CONVERSATIONS = gql`
mutation analyzeConversations ($conversations: [Int!]!) {
  analyzeConversations(conversations: $conversations) {
    __typename
    ... on AnalyzeConversations {
      alreadyAnalyzed {
        analyzedAt
        conversation
        score
      }
      dispatched
      rejected {
        conversation
        reason
      }
    }
    ... on Error {
      code
      info
    }
  }
}
`;
